<template>
  <div>
    <vxe-modal
      v-model="dialogVisible"
      :before-hide-method="handleClose"
      width="80%"
      show-zoom
      resize
      transfer
    >
      <template #title>
        <span>课程中心</span>
      </template>
      <template #default>
        <div class="single-content-wrapper">
          <div
            class="switch-display border-all"
            style="padding-top: 1rem; padding-bottom: 1rem"
          >
            <el-steps :active="active" align-center>
              <el-step title="第一步:编辑课程信息"></el-step>
              <el-step title="第二步:编辑章节内容"></el-step>
              <el-step title="第三步:设置课程规则"></el-step>
            </el-steps>
          </div>

          <!-- 第一步-->
          <div
            class="switch-display border-all"
            style="min-height: 20rem; padding-top: 2rem; padding-bottom: 2rem"
            v-show="active == 0"
          >
            <div class="switch-content">
              <el-form :model="SelectData" :rules="rules" size="small">
                <div class="formtable">
                  <el-row :gutter="20" class="row-bg">
                    <el-col :span="6">
                      <div class="grid-content bg-purple">
                        <el-form-item label="课程标题:" prop="title">
                          <el-input
                            id="title"
                            v-model="SelectData.title"
                            clearable
                            :disabled="IsReadonly"
                            maxlength="50"
                          />
                        </el-form-item>
                      </div>
                    </el-col>

                    <el-col :span="6">
                      <div class="grid-content bg-purple">
                        <el-form-item label="讲师:" prop="teacherId">
                          <el-select
                            v-model="SelectData.teacherId"
                            placeholder="讲师"
                            :disabled="IsReadonly"
                          >
                            <el-option
                              v-for="item in teachers"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20" class="row-bg">
                    <el-col :span="12">
                      <div class="grid-content bg-purple">
                        <el-form-item label="课程分类:" prop="courseCategoryId">
                          <el-select
                            style="width: 10rem"
                            v-model="CourseCategory.cc1"
                            :disabled="IsReadonly"
                            @change="CourseCategory.cc1Change"
                            class="m-2"
                            placeholder="一级分类"
                            size="large"
                          >
                            <el-option
                              v-for="item in CourseCategory.CourseCategoryList1"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id"
                            >
                            </el-option>
                          </el-select>

                          <el-select
                            style="width: 10rem"
                            v-model="CourseCategory.cc2"
                            :disabled="IsReadonly"
                            @change="CourseCategory.cc2Change"
                            v-show="CourseCategory.cc2Show"
                            class="m-2"
                            placeholder="二级分类"
                            size="large"
                          >
                            <el-option
                              v-for="item in CourseCategory.CourseCategoryList2"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id"
                            >
                            </el-option>
                          </el-select>

                          <!-- <el-select
                            style="width: 10rem"
                            v-model="CourseCategory.cc3"
                            :disabled="IsReadonly"
                            v-show="CourseCategory.cc3Show"
                            class="m-2"
                            placeholder="Select"
                            size="large"
                          >
                            <el-option
                              v-for="item in CourseCategory.CourseCategoryList3"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id"
                            >
                            </el-option>
                          </el-select> -->
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>

                  <el-row :gutter="24" class="row-bg">
                    <el-col :span="24">
                      <div class="grid-content bg-purple">
                        <el-form-item label="课程简介:" prop="introduction">
                          <el-input
                            rows="4"
                            type="textarea"
                            id="introduction"
                            v-model="SelectData.introduction"
                            clearable
                            :disabled="IsReadonly"
                          />
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </el-form>
            </div>
          </div>

          <!-- 第二步-->
          <div
            class="switch-display border-all"
            style="min-height: 20rem; padding-top: 2rem; padding-bottom: 2rem"
            v-show="active == 1"
          >
            <div class="switch-content">
              <el-form :model="SelectData" :rules="rules" size="small">
                <div class="formtable">
                  <div class="operation">
                    <!-- <el-button
                      class="custom-button"
                      type="primary"
                      :icon="Search"
                      @click="CourseChapterEditClick(-1, 'Add')"
                      v-show="OpStatus != 'Detail'"
                    >
                      <i class="el-icon-circle-plus-outline custom-icon"></i>
                      <span>新增章节</span>
                    </el-button> -->

                    <vxe-toolbar>
                      <template #buttons>
                        <vxe-button icon="fa fa-plus" @click="insertEvent(-1)"
                          >新增</vxe-button
                        >
                        <vxe-button @click="onRemoveCheckboxRow()"
                          >删除选中</vxe-button
                        >
                      </template>
                    </vxe-toolbar>
                  </div>
                  <div class="custom-table-layer">
                    <div id="custom-table-layer" style="margin-bottom: 13px">
                      <!-- <vxe-table
                        border
                        show-overflow
                        keep-source
                        ref="xTable"
                        max-height="400"
                        :data="DataList"
                        :edit-config="{
                          trigger: 'click',
                          mode: 'cell',
                          icon: 'fa fa-pencil',
                          showStatus: true,
                        }"
                      >
                        <vxe-column type="checkbox" width="60"></vxe-column>

                        <vxe-column type="seq" title="序号" width="60"></vxe-column>

                        <vxe-column title="序号" width="60">
                          <template #default="{ rowIndex, row }">
                            <span>{{ setNumber(rowIndex, row) }}</span>
                          </template>
                        </vxe-column>

                        <vxe-column
                          field="title"
                          title="章节标题"
                          sortable
                          :edit-render="{
                            autofocus: '.vxe-input--inner',
                            defaultValue: '章节标题',
                          }"
                        >
                          <template #edit="{ row }">
                            <vxe-input
                              v-model="row.title"
                              type="text"
                            ></vxe-input>
                          </template>
                        </vxe-column>

                        <vxe-column
                          field="mins"
                          title="课程时长"
                          sortable
                          :edit-render="{
                            autofocus: '.vxe-input--inner',
                            defaultValue: '0',
                          }"
                          v-if="false"
                        >
                          <template #edit="{ row }">
                            <vxe-input
                              v-model="row.mins"
                              type="number"
                            ></vxe-input>
                          </template>
                        </vxe-column>

                        <vxe-column field="imgUrl" title="章节封面">
                          <template #default="{ row }">
                            <img
                              :src="headIMG(row.imgUrl)"
                              @click="imageClick('1', row)"
                              title="点我选择章节封面"
                              style="width: 60px; height: 60px; cursor: pointer"
                            />
                          </template>
                        </vxe-column>

                        <vxe-column field="fileName" title="章节文件">
                          <template v-slot="{ row }">
                            <vxe-button
                              size="mini"
                              plain
                              class="el-icon-plus"
                              title="点我选择章节文件"
                              @click="imageClick('2', row)"
                              type="primary"
                            >
                            </vxe-button>
                            {{ row.fileName }}
                          </template>
                        </vxe-column>
                      </vxe-table> -->
                      <el-table
                        :data="DataList"
                        border
                        ref="xTable"
                        max-height="400"
                        style="width: 100%"
                        :key="tableKey"
                        @selection-change="handleSelectionChange"
                      >
                        <el-table-column
                          type="selection"
                          align="center"
                          width="60"
                        />
                        <el-table-column
                          type="index"
                          label="序号"
                          align="center"
                          width="60"
                        />
                        <el-table-column
                          prop="title"
                          label="章节标题"
                          width="220"
                          show-overflow-tooltip
                        >
                          <template
                            :key="tableKey"
                            v-if="!IsReadonly"
                            #default="{ row }"
                          >
                            <vxe-input
                              v-model="row.title"
                              type="text"
                              placeholder="章节标题"
                            ></vxe-input>
                          </template>
                        </el-table-column>
                        <el-table-column
                          prop="mins"
                          label="课程时长"
                          width="100"
                          align="center"
                          v-if="false"
                        >
                          <template
                            :key="tableKey"
                            v-if="!IsReadonly"
                            #default="{ row }"
                          >
                            <vxe-input
                              v-model="row.mins"
                              type="number"
                              placeholder="课程时长"
                              style="width: 100%"
                            ></vxe-input>
                          </template>
                        </el-table-column>
                        <el-table-column
                          prop="imgUrl"
                          label="章节封面"
                          width="100"
                          align="center"
                        >
                          <template :key="tableKey" #default="{ row }">
                            <img
                              :src="headIMG(row.imgUrl)"
                              @click="imageClick('1', row)"
                              title="点我选择章节封面"
                              style="width: 60px; height: 60px; cursor: pointer"
                            />
                          </template>
                        </el-table-column>
                        <el-table-column
                          prop="fileName"
                          label="章节文件"
                          show-overflow-tooltip
                        >
                          <template :key="tableKey" #default="{ row }">
                            <vxe-button
                              v-if="!IsReadonly"
                              size="mini"
                              plain
                              class="el-icon-plus"
                              title="点我选择章节文件"
                              @click="imageClick('2', row)"
                              type="primary"
                            >
                            </vxe-button>
                            {{ row.fileName }}
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                    <!-- <div class="pagination">
                      <vxe-pager
                        perfect
                        size="mini"
                        :current-page="PageQuery.pageindex"
                        :page-size="PageQuery.PageSize"
                        :page-sizes="[20, 50, 100, 500]"
                        :total="total"
                        :pager-count="5"
                        :layouts="[
                          'PrevJump',
                          'PrevPage',
                          'JumpNumber',
                          'NextPage',
                          'NextJump',
                          'FullJump',
                          'Sizes',
                          'Total',
                        ]"
                        @page-change="handlePageChange"
                      >
                      </vxe-pager> 
                    </div>-->
                  </div>
                </div>
              </el-form>
              <!-- <CourseChapterEdit
                ref="CourseChapterEdit"
                v-model:courseChapterDialogVisible="courseChapterDialogVisible"
                @close-dialog="courseChapterCloseDialog"
                @handle-cancel="courseChapterHandleCancel"
                @handle-confirm="courseChapterHandleConfirm"
              ></CourseChapterEdit> -->

              <SubResourceCenter
                ref="SubResourceCenter"
                v-model:ResourceCenterDialogVisible="
                  ResourceCenterDialogVisible
                "
                @close-dialog="ResourceCenterCloseDialog"
                @handle-cancel="ResourceCenterHandleCancel"
                @handle-confirm="ResourceCenterHandleConfirm"
              ></SubResourceCenter>
            </div>
          </div>

          <!-- 第三步-->
          <div
            class="switch-display border-all"
            style="min-height: 20rem; padding-top: 2rem; padding-bottom: 2rem"
            v-show="active == 2"
          >
            <div class="switch-content">
              <el-form :model="SelectData" :rules="rules" size="small">
                <div class="formtable">
                  <el-row :gutter="20" class="row-bg">
                    <el-col :span="20">
                      <div class="grid-content bg-purple">
                        <el-form-item
                          label="课程公开范围:"
                          prop="type"
                          label-width="400"
                          label-position="right"
                        >
                          <el-radio
                            v-model="SelectData.type"
                            label="0"
                            size="large"
                            :disabled="IsReadonly"
                            >企业公开</el-radio
                          >
                          <el-radio
                            v-model="SelectData.type"
                            label="1"
                            size="large"
                            :disabled="IsReadonly"
                            >平台公开</el-radio
                          >
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20" class="row-bg">
                    <el-col :span="20">
                      <div class="grid-content bg-purple">
                        <el-form-item
                          label="禁止拖动视频进度:"
                          prop="isExpedite"
                          label-width="400"
                          label-position="right"
                        >
                          <el-switch
                            v-model="SelectData.isExpedite"
                            active-text="是"
                            inactive-text="否"
                            :disabled="IsReadonly"
                          />
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20" class="row-bg">
                    <el-col :span="20">
                      <div class="grid-content bg-purple">
                        <el-form-item
                          label="是否好课:"
                          prop="isGoodClass"
                          label-width="400"
                          label-position="right"
                        >
                          <el-switch
                            v-model="SelectData.isGoodClass"
                            active-text="是"
                            inactive-text="否"
                            :disabled="IsReadonly"
                          />
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20" class="row-bg">
                    <el-col :span="20">
                      <div class="grid-content bg-purple">
                        <el-form-item
                          label="关联试卷:"
                          prop="isRelatePaper"
                          label-width="400"
                          label-position="right"
                        >
                          <el-switch
                            v-model="SelectData.isRelatePaper"
                            active-text="是"
                            inactive-text="否"
                            :disabled="IsReadonly"
                          />
                          <el-button
                            v-show="SelectData.isRelatePaper && !IsReadonly"
                            style="margin-left: 12px"
                            size="mini"
                            @click="goCourseSelect"
                            >选择试卷</el-button
                          >
                          <div v-if="examInfo != null" class="examlist">
                            <img
                              src="@/assets/images/exam.png"
                              class="examlist-icon"
                            />
                            <label class="examlist-title">{{
                              examInfo.name
                            }}</label>
                            <i
                              v-if="!IsReadonly"
                              title="删除"
                              class="el-icon-delete examlist-btn"
                              @click="deleteexam"
                            ></i>
                          </div>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </el-form>
            </div>
          </div>

          <!-- 按钮 -->
          <div
            class="switch-display border-all"
            style="text-align: center; padding-bottom: 1rem"
          >
            <el-button style="margin-top: 12px" @click="handleCancel"
              >返回列表</el-button
            >
            <el-button
              style="margin-top: 12px"
              @click="prev"
              v-show="active != 0"
              >上一步</el-button
            >
            <el-button
              style="margin-top: 12px"
              @click="next"
              v-show="active != 2"
              >保存并下一步</el-button
            >
            <el-button
              style="margin-top: 12px"
              @click="handleConfirm"
              v-show="active == 2 && IsShowConfirm"
              >保存并提交</el-button
            >
          </div>
        </div>
      </template>
    </vxe-modal>
    <CourseSelect
      ref="CourseSelect"
      v-model:courseSelectDoalog="courseSelectDoalog"
      @close-dialog="courseSelectClose"
      @handle-cancel="courseSelectCancel"
      @handle-confirm="courseSelectConfirm"
    ></CourseSelect>
  </div>
</template>

<script>
import { SelectCourseById, SaveCourseData } from "@api/ApiCourse";

import CourseChapterEdit from "@comp/Course/CourseChapterEdit.vue";

import SubResourceCenter from "@views/YZResource/SubResourceCenter.vue";

import Sortable from "sortablejs";

import {
  GetDataCourseChapterListByPageQuery,
  DeleteCourseChapter,
} from "@api/ApiCourseChapter";

import { GetDataTeacherList } from "@api/Course/ApiTeacher";

import {
  GetCourseCategoryListById,
  GetDataCourseCategoryList,
} from "@api/ApiCourseCategory";
import { ossPreview } from "@/util/ossClient.js";
import { getUserInfo } from "@/util/authority";
import CourseSelect from "./CourseSelect.vue";
import { SelectExamById } from "@api/Exam/ApiExam";
import { isReadonly } from "@vue/reactivity";

export default {
  name: "CourseEdit",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "",
    },
    GUID: {
      type: String,
      default: "",
    },
  },
  components: {
    CourseChapterEdit,
    SubResourceCenter,
    CourseSelect,
  },
  data() {
    return {
      courseChapterDialogVisible: false,
      ResourceCenterDialogVisible: false,
      CourseCategory: {
        cc1: "",
        cc2: "",
        cc3: "",
        cc1Change: this.courseCategory1Change,
        cc2Change: this.courseCategory2Change,
        cc2Show: false,
        cc3Show: false,
        CourseCategoryList1: [],
        CourseCategoryList2: [],
        CourseCategoryList3: [],
      },
      SelectData: {
        id: 0,
      },
      courseId: 0,
      IsReadonly: false,
      IsShowConfirm: true,
      OpStatus: "Detail",
      active: 0,
      DataList: [],
      tableKey: 1,
      PageQuery: {
        queryModel: {
          name: "",
        },
        pageindex: 1,
        PageSize: 20,
      },
      total: 0,
      CourseChapterModel: {},
      userinfo: getUserInfo(),
      teachers: [],
      courseSelectDoalog: false,
      examInfo: null,
      multipleSelection: [],
      removeDataList: [],
    };
  },
  watch: {
    active(val) {
      if (val === 1) {
        this.rowDrop();
      }
    },
    dialogVisible() {
      this.multipleSelection = [];
    },
  },
  created() {},
  mounted() {},
  methods: {
    //行拖拽
    rowDrop() {
      const tbody = document.querySelector(".el-table__body-wrapper tbody");
      const _this = this;
      Sortable.create(tbody, {
        draggable: ".el-table__row",
        onEnd({ newIndex, oldIndex }) {
          const oldItem = _this.DataList[oldIndex];
          const newItem = _this.DataList[newIndex];
          _this.DataList[newIndex] = oldItem;
          _this.DataList[oldIndex] = newItem;
          _this.tableKey += 1;
          _this.$nextTick(() => {
            _this.rowDrop();
          });
        },
      });
    },
    //章节图片路径设定
    headIMG(img) {
      const imgData = require("../../assets/images/logo.png");
      if (img) {
        return ossPreview(img, "1");
      } else {
        return imgData;
      }
      // return img ? img : imgData
    },
    //打开资源弹框入口
    imageClick: function (type, row) {
      if (this.IsReadonly) return;
      // { GroupTypeCode: "1", GroupTypeName: "图片" },
      // { GroupTypeCode: "2", GroupTypeName: "视频" },
      // { GroupTypeCode: "3", GroupTypeName: "文档" },
      //debugger
      this.ResourceCenterDialogVisible = true;
      var obj = {
        type: [type], //展示的页签
        selectFileType: "1", //选中的文件的类型 1图片，2视频，3文档
        selectId: 0, //选中的文件的id
        isSingle: true, //是否单选
        source: "CourseEdit", //数据来源页面
        row: row, //行
        sourceItem: {}, //资源文件对象
      };
      if (type == "1") {
        obj.selectFileType = "1";
        obj.selectId = row.imageId;
        obj.type = ["1"];
      } else if (type == "2") {
        obj.selectFileType = "2"; //row.fileType == undefined ? '2' : row.fileType
        obj.selectId = row.resourcesId;
        obj.type = ["2", "3"];
      }

      this.$refs.SubResourceCenter.loading(obj);
    },
    //章节 新增
    insertEvent(row) {
      const $table = this.$refs.xTable;
      const record = { id: undefined, timeTmp: new Date().getTime() };
      this.DataList.push(record);
      // const { row: newRow } = $table.insertAt(record, row);
      // $table.setActiveCell(newRow, "name");
    },
    // 章节 删除
    onRemoveCheckboxRow() {
      if (this.DataList.length === this.multipleSelection.length) {
        this.DataList = [];
      } else {
        let list = [];
        this.DataList.forEach((item) => {
          this.multipleSelection.forEach((row) => {
            if (item.timeTmp !== row.timeTmp) {
              list.push(item);
            }
          });
        });
        this.DataList = this.uniqueFunc(list, "timeTmp");
      }
    },
    uniqueFunc(arr, uniId) {
      const res = new Map();
      return arr.filter(
        (item) => !res.has(item[uniId]) && res.set(item[uniId], 1)
      );
    },
    //章节保存 数据处理
    saveEvent() {
      this.DataList.forEach((item, index) => {
        item.number = index + 1;
      });
      // 新增数据
      const insertRecords = this.DataList.filter((item) => !item.id);
      // 编辑数据
      const updateRecords = this.DataList.filter((item) => item.id);
      // 删除数据
      const removeRecords = this.uniqueFunc(
        this.removeDataList,
        "timeTmp"
      ).filter((item) => item.id);
      // const $table = this.$refs.xTable;
      // const { insertRecords, removeRecords, updateRecords } =
      //   $table.getRecordset();
      this.CourseChapterModel.InsertList = insertRecords;
      this.CourseChapterModel.UpdateList = updateRecords;
      this.CourseChapterModel.DeleteList = removeRecords;
      if (this.DataList.length > 0) {
        this.DataList.forEach((item) => {
          if (item["edit"]) {
            let existsdel =
              this.CourseChapterModel.DeleteList.indexOf(item) >= 0;
            if (!existsdel) {
              let existsup =
                this.CourseChapterModel.UpdateList.indexOf(item) >= 0;
              if (!existsup) {
                this.CourseChapterModel.UpdateList.push(item);
              }
            }
          }
        });
      }
    },
    //一级分类change事件
    courseCategory1Change(val) {
      var _this = this;
      _this.CourseCategory.cc2Show = true;
      _this.CourseCategory.CourseCategoryList2 = [];
      _this.CourseCategory.CourseCategoryList3 = [];
      _this.CourseCategory.cc2 = "";
      _this.CourseCategory.cc3 = "";
      GetDataCourseCategoryList({
        queryModel: {
          parentId: val,
        },
        pageindex: 1,
        PageSize: 1000,
      }).then(function (data) {
        _this.CourseCategory.CourseCategoryList2 = data.entities;
      });
    },
    //二级分类change事件
    courseCategory2Change(val) {
      var _this = this;
      _this.CourseCategory.cc3Show = true;
      _this.CourseCategory.CourseCategoryList3 = [];
      _this.CourseCategory.cc3 = "";
      GetDataCourseCategoryList({
        queryModel: {
          parentId: val,
        },
        pageindex: 1,
        PageSize: 1000,
      }).then(function (data) {
        _this.CourseCategory.CourseCategoryList3 = data.entities;
      });
    },
    //加载分类
    loadCourseCategoryData() {
      var _this = this;
      GetDataCourseCategoryList({
        queryModel: {
          parentId: 0,
        },
        pageindex: 1,
        PageSize: 1000,
      }).then(function (data) {
        _this.CourseCategory.CourseCategoryList1 = data.entities;
      });
    },
    //加载讲师
    loadTeachers() {
      let _this = this;
      GetDataTeacherList({
        queryModel: {},
        pageindex: 1,
        PageSize: 10000,
      }).then((res) => {
        _this.teachers = res.entities;
      });
    },
    //加载数据
    GetData() {
      const _this = this;
      try {
        _this.PageQuery.queryModel.courseId = _this.courseId;
        GetDataCourseChapterListByPageQuery(_this.PageQuery).then(function (
          data
        ) {
          _this.DataList = data.entities;
          _this.total = data.totalCount;
          _this.DataList.forEach((item, index) => {
            item.timeTmp = index + new Date().getTime();
          });
        });
      } catch (e) {
        console.log(e);
      }
    },
    //分页
    handlePageChange({ currentPage, pageSize }) {
      if (this.PageQuery.PageSize != pageSize) {
        this.PageQuery.pageindex = 1; //说明更改了每页展示条数，要从第一页进行展示
        this.PageQuery.PageSize = pageSize;
      } else {
        this.PageQuery.pageindex = currentPage;
      }
      this.GetData();
    },
    //选中事件
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.removeDataList = [...this.removeDataList, ...val];
    },
    handleCurrentChange(val) {
      console.log(val);
      this.GetData();
    },
    CourseChapterEditClick(index, type) {
      var _this = this;
      if (type == "Delete") {
        DeleteCourseChapter(this.DataList[index].id).then(function (data) {
          if (data) {
            _this.$message.success("删除成功");
            _this.PageQuery.pageindex = 1;
            _this.GetData();
          }
        });
      } else {
        this.courseChapterDialogVisible = true;
        var id = 0;
        if (type != "Add") id = _this.DataList[index].id;
        this.$refs.CourseChapterEdit.loadDataById(this.courseId, id, type);
      }
    },
    //上一步
    prev() {
      if (this.active == 0) this.active = 0;
      else {
        this.active--;

        if (this.active == 1) {
          this.GetData();
        }
      }
    },
    //下一步
    next() {
      if (this.active == 2) this.active = 0;
      else {
        this.active++;
        if (this.active == 1) {
          this.GetData();
        }
      }
    },
    courseChapterCloseDialog() {
      this.courseChapterDialogVisible = false;
    },
    courseChapterHandleCancel() {
      this.courseChapterDialogVisible = false;
    },
    courseChapterHandleConfirm(val) {
      this.courseChapterDialogVisible = false;
      this.PageQuery.pageindex = 1;
      this.GetData();
    },
    ResourceCenterCloseDialog() {
      this.ResourceCenterDialogVisible = false;
    },
    ResourceCenterHandleCancel() {
      this.ResourceCenterDialogVisible = false;
    },
    //选择资源文件之后 点击确认的回调事件
    ResourceCenterHandleConfirm(obj) {
      this.ResourceCenterDialogVisible = false;
      if (obj.selectFileType == 1) {
        obj.row.imageId = obj.sourceItem[0].PicLogicalCode;
        obj.row.imgName = obj.sourceItem[0].FileName;
        obj.row.imgUrl = obj.sourceItem[0].ImgSrc;
      } else if (obj.selectFileType == 2 || obj.selectFileType == 3) {
        //  获取视频时长
        obj.row.mins = 0;
        if(obj.groupTypeCode == "2") {
          var audioElement = new Audio(obj.sourceItem[0].ImgSrcNew);
          let loading = this.$loading({
            lock: true,
            text: "获取视频时长",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          try
          {
            audioElement.addEventListener("loadedmetadata", function () {
              obj.row.mins = parseInt(audioElement.duration);
              console.log(obj.sourceItem[0].FileName + ":" + obj.row.mins);
              loading.close();
            });
          }
          catch (error) {
            loading.close();
          }
        }
        obj.row.resourcesId = obj.sourceItem[0].PicLogicalCode;
        obj.row.fileName = obj.sourceItem[0].FileName;
        obj.row.fileUrl = obj.sourceItem[0].ImgSrc;
      }
    },
    /**
     * type==> Add,Modify,Detail
     */
    loadDataById(id, type) {
      const _this = this;
      _this.IsReadonly = false;
      _this.IsShowConfirm = true;
      _this.OpStatus = type;
      _this.DataList = [];

      _this.active = 0;
      _this.courseId = id;
      _this.SelectData = {};
      _this.CourseCategory = {
        cc1: "",
        cc2: "",
        cc3: "",
        cc1Change: this.courseCategory1Change,
        cc2Change: this.courseCategory2Change,
        cc2Show: false,
        cc3Show: false,
        CourseCategoryList1: [],
        CourseCategoryList2: [],
        CourseCategoryList3: [],
      };
      _this.examInfo = null;

      _this.loadCourseCategoryData(); //加载分类
      _this.loadTeachers(); // 加载讲师
      //增加子节点
      if (type == "Add") {
        _this.SelectData.isExpedite = true;
        _this.SelectData.type = "1";
        _this.SelectData.companyId = _this.userinfo.CompanyId;

        return;
      }

      if (type == "Detail") {
        _this.IsReadonly = true;
        _this.IsShowConfirm = false;
      }
      SelectCourseById(id).then(function (data) {
        _this.SelectData = data;
        _this.SelectData.type = data.type + "";
        _this.CourseCategory.cc2 = data.courseCategoryId;
        _this.edit_loadCourseCategoryData();
        _this.getexaminfo();
      });
    },
    edit_loadCourseCategoryData() {
      var _this = this;
      GetCourseCategoryListById(_this.CourseCategory.cc2).then(function (data) {
        _this.CourseCategory.CourseCategoryList2 = data.secondData;
        _this.CourseCategory.CourseCategoryList1 = data.firstData;
        _this.CourseCategory.cc1 = data.cc1;
        _this.CourseCategory.cc2 = _this.CourseCategory.cc2;
        _this.CourseCategory.cc2Show = true;
        _this.CourseCategory.cc3Show = true;
      });
    },
    getexaminfo() {
      let _this = this;
      if (this.SelectData.examId > 0) {
        SelectExamById(this.SelectData.examId).then((result) => {
          _this.examInfo = result;
        });
      }
    },
    deleteexam() {
      this.SelectData.examId = 0;
      this.examInfo = null;
    },
    handleSelect(item) {
      console.log(item);
    },
    handleClose() {
      this.$emit("close-dialog");
    },
    handleCancel() {
      this.$emit("handle-cancel");
    },
    handleConfirm() {
      var _this = this;

      if (!this.validate()) {
        return;
      }

      _this.saveEvent();

      _this.IsShowConfirm = false;
      SaveCourseData({
        Status: _this.OpStatus,
        CourseDTO: _this.SelectData,
        CourseChapterModel: _this.CourseChapterModel,
      }).then(function (data) {
        _this.IsShowConfirm = true;
        _this.removeDataList = [];
        _this.multipleSelection = [];
        _this.$message.success("操作成功!");
        _this.$emit("handle-confirm");
      });
      // if (_this.OpStatus == "Add") {
      //   AddCourse(_this.SelectData).then(function (data) {
      //     _this.$message.success("新增成功!");
      //     _this.$emit("handle-confirm");
      //   });
      // } else if (_this.OpStatus == "Modify") {
      //   ModifyCourse(_this.SelectData).then(function (data) {
      //     _this.$message.success("编辑成功!");
      //     _this.$emit("handle-confirm");
      //   });
      // }
    },
    validate() {
      if (!this.SelectData.title || this.SelectData.title == "") {
        this.$message.error("课程标题是必须的!");
        return false;
      }
      if (this.CourseCategory.cc2 == "") {
        this.$message.error("分类是必须的!");
        return false;
      }
      this.SelectData.courseCategoryId = this.CourseCategory.cc2;
      return true;
    },
    //设置序号
    setNumber(rowIndex, row) {
      const $table = this.$refs.xTable;
      if (row["number"] != rowIndex + 1) {
        row["number"] = rowIndex + 1;
        row["edit"] = true;
      }
      return row["number"];
    },
    courseSelectClose() {
      this.courseSelectDoalog = false;
    },
    courseSelectCancel() {
      this.courseSelectDoalog = false;
    },
    courseSelectConfirm(val) {
      this.SelectData.examId = val;
      this.getexaminfo();
      this.courseSelectDoalog = false;
    },
    goCourseSelect() {
      this.courseSelectDoalog = true;
      this.$refs.CourseSelect.initData();
    },
  },
};
</script>

<style lang="scss" scoped>
.formtable {
  padding: 0 20px;
}

.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  border-radius: 4px;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.row-bg {
  padding: 5px 0;
}

.Commit {
  padding: 20px 0;
  text-align: center;
}
.grid-content .el-form-item__label {
  width: 80px;
  padding: 0;
  text-align: left;
}
// .grid-content1 .el-form-item__label {
//   width: 140px;
//   padding: 0;
//   text-align: left;
// }
.tyyzm ::v-deep .el-form-item__label {
  width: 120px;
}
.textarea-note {
  font-size: var(--el-form-label-font-size);
  padding: 5px 0;
}
.el-textarea {
  margin: 5px 0;
  width: 100%;
}
.btn-row {
  height: 40px;
  line-height: 40px;
  margin-bottom: 5px;
}

.option {
  margin: 0px 0 20px 20px;
  .el-button {
    min-height: 0;
    background: #1c6de4;
    border-radius: 3px;
    font-size: 12px;
    color: #ffffff;
    padding: 12px 20px;
    border: 0;

    .custom-icon {
      font-size: 18px;
      vertical-align: text-bottom;
    }
  }
}
.single-content-wrapper {
  min-height: 60vh;
  background-color: #fff;
  padding-bottom: 15px;
}
.switch-display {
  position: relative;
}
.border-all {
  border: 1px solid #dcdfe6;
}
</style>
<style lang="less" scoped>
.examlist {
  display: flex;
  align-items: center;
  cursor: pointer;
  &-icon {
    width: 14px;
    height: 14px;
    box-sizing: border-box;
  }
  &-title {
    font-size: 12px;
    color: #3d3d3d;
    font-weight: 500;
    padding-left: 8px;
  }
  &-btn {
    padding-left: 40px;
    font-size: 14px;
  }
}
</style>
